import { FaSearch } from "react-icons/fa";
import { useSearch } from "../../context/SearchContext";
import { archive } from "../Header/header_svg";
import { useLocation, useNavigate } from "react-router-dom";

export const SearchInput = () => {
  const { searchQuery, setSearchQuery } = useSearch();
  const location = useLocation();
  const navigate = useNavigate();


  const handleArchiveClick = () => {
    if (location.pathname === "/search") {
      navigate(-1);
    } else {
      navigate("/search");
    }
  };

  return (
    <>
      <div className={`flex h-[100%] w-[527px] border-[1px] ${location.pathname ==="/search"?"border-[#739D00]" :"border-[#D9D9D9]"} rounded-l-[10px]`}>
        <input
          type="search"
          placeholder="Search by orders, designer, manager, data, client..."
          className="h-full w-full text-center rounded-l-[10px] outline-none"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <div className="flex w-[51px] items-center justify-center bg-[#FFFFFF]">
          <FaSearch className="text-[#739D00] text-[20px]" />
        </div>
      </div>
      <div
        onClick={handleArchiveClick}
        className={`flex justify-center items-center h-[100%] w-[120px] ${location.pathname ==="/search"?"bg-[#739D00]" :"bg-[#D9D9D9]"} hover:bg-[#739D00] rounded-r-[10px] cursor-pointer`}
      >
        {archive}
      </div>
    </>
  );
};